import React from 'react';
import { CustomButton } from '@buttons/CustomButton';
import Responsability from '@assets/images/responsabilidad_civil.svg';
import Medic from '@assets/images/Medic.svg';
import Legal from '@assets/images/Shield.svg';
import Thief from '@assets/images/Robo.svg';
import Car from '@assets/images/daños-materiales.svg';
import Assist from '@assets/images/asistencia_viajes.svg';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

export const CoveragePlan: React.FC = () => {
  const { breakpoints, palette } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.down('lg'));
  const isTable = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isMedium = useMediaQuery('(max-width:1100px)');

  let stylesParaph = {
    fontSize: '12px',
    fontWeight: 400,
    textAlign: 'center',
    lineHeight: '14.64px',
    margin: isMobile ? '16px 0' : 'unset',
    padding: isMobile ? 'unset' : '20px 10px',
  };

  let stylesSubTitle = {
    fontSize: '14px',
    fontWeight: 700,
    textAlign: 'center',
    lineHeight: '24px',
  };

  return !isTable ? (
    <Box
      width={!isDesktop ? '1228px' : '824px'}
      height={'304px'}
      margin={'auto'}
      border={'1px solid #C0E6F2'}
      borderRadius={'8px'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-around'}
    >
      <Box
        width={!isDesktop ? '1180px' : '776px'}
        height={isMedium ? '195px' : '184px'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={isMedium ? 'flex-start' : 'space-around'}
        margin={'0 auto'}
        flexShrink={'revert'}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '22px',
              fontWeight: 700,
              letterSpacing: '.25px',
              lineHeight: '28px',
              textAlign: 'center',
              borderBottom: '1px solid rgb(199, 199, 199, .4)',
              height: '40px',
            }}
          >
            Amplio
          </Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'209px'}
            height={'124px'}
            borderRight={'1px solid #C7C7C7'}
          >
            <Box
              component={'img'}
              src={Car}
              paddingTop={isMedium ? '10px' : '0'}
            ></Box>
            <Typography sx={stylesSubTitle}>Daños Materiales</Typography>
            <Typography
              sx={stylesParaph}
              style={{ padding: isMedium ? '0 5px' : '20px 10px' }}
            >
              Por si tu vehículo se daña en algún accidente vial o desastre
              natural
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'209px'}
            height={'124px'}
            borderRight={'1px solid #C7C7C7'}
            paddingRight={'10px'}
          >
            <Box
              component={'img'}
              src={Thief}
              paddingTop={isMedium ? '10px' : '0'}
            ></Box>
            <Typography sx={stylesSubTitle}>Robo total</Typography>
            <Typography sx={stylesParaph}>
              Si te roban tu vehículo, tu seguro te cubre su valor comercial o
              el de la factura
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'209px'}
            height={'124px'}
            borderRight={'1px solid #C7C7C7'}
          >
            <Box
              component={'img'}
              src={Responsability}
              paddingTop={isMedium ? '10px' : '0'}
            ></Box>
            <Typography sx={stylesSubTitle}>Responsabilidad civil</Typography>
            <Typography
              sx={stylesParaph}
              style={{ padding: isMedium ? '0 5px' : '20px 10px' }}
            >
              Por si llegas a dañar con tu vehículo a otras personas o sus
              bienes en un accidente vial
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'209px'}
            height={'124px'}
            borderRight={'1px solid #C7C7C7'}
          >
            <Box
              component={'img'}
              src={Medic}
              paddingTop={isMedium ? '10px' : '0'}
            ></Box>
            <Typography sx={stylesSubTitle}>Gastos médicos</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas ayuda médica por un accidente vial o robo
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'209px'}
            height={'124px'}
            borderRight={'1px solid #C7C7C7'}
            paddingRight={'10px'}
          >
            <Box
              component={'img'}
              src={Legal}
              paddingTop={isMedium ? '10px' : '0'}
            ></Box>
            <Typography sx={stylesSubTitle}>Defensa legal</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas pagar abogados u otros gastos legales
            </Typography>
          </Box>

          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'209px'}
            height={'124px'}
          >
            <Box
              component={'img'}
              src={Assist}
              paddingTop={isMedium ? '10px' : '0'}
            ></Box>
            <Typography sx={stylesSubTitle}>Asistencia en viajes</Typography>
            <Typography
              sx={stylesParaph}
              style={{ padding: isMedium ? '0 5px' : '20px 10px' }}
            >
              Por si necesitas asistencia vial en un viaje en tu vehículo
            </Typography>
          </Box>
        </Box>
      </Box>
      <CustomButton
        text={'¡Quiero Cotizar!'}
        onClick={() => {
          window.scrollTo({ top: 3350, left: 0, behavior: 'smooth' });
        }}
        variant={'contained'}
        style={{
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          textTransform: 'uppercase',
          borderRadius: '10px',
          width: ' 300px',
          height: '48px',
          alignSelf: 'center',
        }}
      />
    </Box>
  ) : !isMobile ? (
    //--------------------Table Experience------------------//
    <Box
      width={'420px'}
      height={'612px'}
      margin={'auto'}
      border={'1px solid #C0E6F2'}
      borderRadius={'8px'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-around'}
    >
      <Box
        width={'372px'}
        height={'492px'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-around'}
        margin={'0 auto'}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              letterSpacing: '.25px',
              lineHeight: '28px',
              textAlign: 'center',
              height: '40px',
            }}
          >
            Amplio
          </Typography>
        </Box>
        <Box width={'100%'}>
          <hr style={{ border: '1px solid rgb(199, 199, 199, .4)' }} />
        </Box>
        <Box
          display={'flex'}
          flexWrap={'wrap'}
          height={'436px'}
          justifyContent={'space-around'}
          alignItems={'center'}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'176px'}
            height={'124px'}
            marginBottom={'10px'}
            borderRight={'1px solid #C7C7C7'}
          >
            <Box component={'img'} src={Car}></Box>
            <Typography sx={stylesSubTitle}>Daños Materiales</Typography>
            <Typography sx={stylesParaph}>
              Por si tu vehículo se daña en algún accidente vial o desastre
              natural
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'176px'}
            marginBottom={'10px'}
            height={'124px'}
          >
            <Box component={'img'} src={Thief}></Box>
            <Typography sx={stylesSubTitle}>Robo total</Typography>
            <Typography sx={stylesParaph}>
              Si te roban tu vehículo, tu seguro te cubre su valor comercial o
              el de la factura
            </Typography>
          </Box>
          <Box width={'100%'}>
            <hr style={{ border: '1px solid rgb(199, 199, 199, .4)' }} />
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'176px'}
            height={'124px'}
            marginBottom={'10px'}
            borderRight={'1px solid #C7C7C7'}
          >
            <Box component={'img'} src={Responsability}></Box>
            <Typography sx={stylesSubTitle}>Responsabilidad Civil</Typography>
            <Typography sx={stylesParaph}>
              Por si llegas a dañar con tu vehículo a otras personas o sus
              bienes en un accidente vial
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            marginBottom={'10px'}
            width={'176px'}
            height={'124px'}
          >
            <Box component={'img'} src={Medic}></Box>
            <Typography sx={stylesSubTitle}>Gastos médicos</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas ayuda médica por un accidente vial o robo
            </Typography>
          </Box>
          <Box width={'100%'}>
            <hr style={{ border: '1px solid rgb(199, 199, 199, .4)' }} />
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            marginBottom={'10px'}
            width={'176px'}
            height={'124px'}
            borderRight={'1px solid #C7C7C7'}
          >
            <Box component={'img'} src={Legal}></Box>
            <Typography sx={stylesSubTitle}>Defensa legal</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas pagar abogados u otros gastos legales
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            margin={'3px  0'}
            width={'176px'}
            height={'124px'}
          >
            <Box component={'img'} src={Assist}></Box>
            <Typography sx={stylesSubTitle}>Asistencia en viajes</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas asistencia vial en un viaje en tu vehículo
            </Typography>
          </Box>
        </Box>
      </Box>
      <CustomButton
        text={'¡Quiero Cotizar!'}
        onClick={() => {
          window.scrollTo({ top: 4100, left: 0, behavior: 'smooth' });
        }}
        variant={'contained'}
        style={{
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          textTransform: 'uppercase',
          borderRadius: '10px',
          width: ' 300px',
          height: '48px',
          alignSelf: 'center',
        }}
      />
    </Box>
  ) : (
    //-----------------Mobile Experience-------------------//
    <Box
      width={'231px'}
      height={'1035px'}
      margin={'auto'}
      border={'1px solid #C0E6F2'}
      borderRadius={'8px'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-around'}
    >
      <Box
        width={'170px'}
        height={'1035px'}
        display={'flex'}
        flexDirection={'column'}
        margin={'0 auto'}
        justifyContent={'center'}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              letterSpacing: '.25px',
              lineHeight: '25px',
              textAlign: 'center',
              borderBottom: '1px solid rgb(199, 199, 199, .4)',
              height: '40px',
            }}
          >
            Amplio
          </Typography>
        </Box>
        <Box
          display={'flex'}
          flexWrap={'wrap'}
          height={'874px'}
          justifyContent={'space-around'}
          alignItems={'center'}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'176px'}
            height={'120px'}
            marginBottom={'10px'}
          >
            <Box component={'img'} src={Car} paddingTop={'16px'}></Box>
            <Typography sx={stylesSubTitle}>Daños Materiales</Typography>
            <Typography sx={stylesParaph}>
              Por si tu vehículo se daña en algún accidente vial o desastre
              natural
            </Typography>
          </Box>
          <Box width={'100%'} height={'1px'}>
            <hr style={{ border: '1px solid #C7C7C7)', margin: '0px' }} />
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'176px'}
            marginBottom={'10px'}
            height={'120px'}
          >
            <Box component={'img'} src={Thief} paddingTop={'16px'}></Box>
            <Typography sx={stylesSubTitle}>Robo total</Typography>
            <Typography sx={stylesParaph}>
              Si te roban tu vehículo, tu seguro te cubre su valor comercial o
              el de la factura
            </Typography>
          </Box>
          <Box width={'100%'} height={'1px'}>
            <hr style={{ border: '1px solid #C7C7C7)', margin: '0px' }} />
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            width={'176px'}
            height={'137px'}
            marginBottom={'10px'}
          >
            <Box
              component={'img'}
              src={Responsability}
              paddingTop={'16px'}
            ></Box>
            <Typography sx={stylesSubTitle}>Responsabilidad Civil</Typography>
            <Typography sx={stylesParaph}>
              Por si llegas a dañar con tu vehículo a otras personas o sus
              bienes en un accidente vial
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            marginBottom={'10px'}
            width={'176px'}
            height={'117px'}
            borderTop={'1px solid #C7C7C7'}
          >
            <Box component={'img'} src={Medic} paddingTop={'16px'}></Box>
            <Typography sx={stylesSubTitle}>Gastos médicos</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas ayuda médica por un accidente vial o robo
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            marginBottom={'10px'}
            width={'176px'}
            height={'117px'}
            borderTop={'1px solid #C7C7C7'}
          >
            <Box component={'img'} src={Legal} paddingTop={'16px'}></Box>
            <Typography sx={stylesSubTitle}>Defensa legal</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas pagar abogados u otros gastos legales
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            margin={'3px  0'}
            width={'176px'}
            height={'124px'}
            borderTop={'1px solid #C7C7C7'}
          >
            <Box component={'img'} src={Assist} paddingTop={'16px'}></Box>
            <Typography sx={stylesSubTitle}>Asistencia en viajes</Typography>
            <Typography sx={stylesParaph}>
              Por si necesitas asistencia vial en un viaje en tu vehículo
            </Typography>
          </Box>
        </Box>
        <Box sx={{ marginTop: '24px' }}></Box>
        <CustomButton
          text={'¡Quiero Cotizar!'}
          onClick={() => {
            window.scrollTo({ top: 5200, left: 0, behavior: 'smooth' });
          }}
          variant={'contained'}
          style={{
            color: palette.common.white,
            backgroundColor: palette.primary.main,
            textTransform: 'uppercase',
            borderRadius: '10px',
            width: ' 201px',
            height: '48px',
            alignSelf: 'center',
          }}
        />
      </Box>
    </Box>
  );
};
